import React from 'react';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { I_FareInfos, I_FlightInfos } from '@Redux/search/interfaces';
import { formatPrice, displayTaxRtow } from '@utils/formatDisplay';

interface I_PriceDetailProps {
    flightData: I_FlightInfos;
    isB2C: boolean;
}

const PriceDetail = ({ flightData, isB2C }: I_PriceDetailProps) => {

    return (
        <div className={styles.infoHover}>
            {!isB2C &&
                <div>
                    <ul>
                        <li>
                            <div>大人票價/位</div>
                            <div>${formatPrice(flightData.FareInfos[0].AdtPriceWithoutTax)}</div>
                        </li>
                        <li>
                            <div>大人稅金/位</div>
                            <div>${formatPrice(flightData.FareInfos[0].AdtPrice - flightData.FareInfos[0].AdtPriceWithoutTax)}</div>
                        </li>
                    </ul>
                    <hr />
                    <ul>
                        <li>
                            <div>小孩票價/位</div>
                            <div>${formatPrice(flightData.FareInfos[0].ChdPriceWithoutTax)}</div>
                        </li>
                        <li>
                            <div>小孩稅金/位</div>
                            <div>${formatPrice(flightData.FareInfos[0].ChdPrice - flightData.FareInfos[0].ChdPriceWithoutTax)}</div>
                        </li>
                    </ul>
                    <hr />
                    <ul>
                        <li>
                            <div>嬰兒票價/位</div>
                            <div>${formatPrice(flightData.FareInfos[0].InfPriceWithoutTax)}</div>
                        </li>
                        <li>
                            <div>嬰兒稅金/位</div>
                            <div>${formatPrice(flightData.FareInfos[0].InfPrice - flightData.FareInfos[0].InfPriceWithoutTax)}</div>
                        </li>
                    </ul>
                    <hr />
                </div>
            }
            {/* 若無票務權限，則隱藏此區塊 */}
            {
                flightData.FareInfos[0].SalesInfos?.LION?.Formula || flightData.FareInfos[0].SalesRule?.Formula ? (
                    <ul className={styles.formula}>
                        <li>加價公式</li>
                        {isB2C ? <div dangerouslySetInnerHTML={{ __html: flightData.FareInfos[0].SalesInfos?.LION?.Formula || "" }} /> :
                            <div dangerouslySetInnerHTML={{ __html: flightData.FareInfos[0].SalesRule?.Formula || "" }} />}
                    </ul>) : null
            }

        </div>
    );

}

export default PriceDetail;